import axios from 'axios';

import { authHeader } from '@H';

export default {
  getPackages: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/subscription/create-subscription-plan/`,
    }),
  getAllFeatures: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/subscription/package-features/`,
    }),
};
